export default `
  .instructional-copy {
    display: block;
    padding-bottom: 12px;
    margin-top: 0.75em;
    margin-bottom: 15px;
    font-size: 17px;
    font-family: var(--font-family-copy);
    font-style: italic;
    text-transform: none;

    a {
      text-decoration: underline;
    }

    &.margin-top {
      margin-top: 30px;
    }

    &.margin-bottom {
      margin-bottom: 30px;
    }
  }
`;
